













































































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";

import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import {
  GetAudioQualityScriptListReq,
  Bool,
  OpenTicketReq,
  AudioQualityScriptData,
  SaveAudioQualityScriptReq,
} from "@/pbjs/external/ticket/ticket_pb";
import {
  ListUserGroupByTypeReq,
  ListUserGroupByMutiTypeReq,
} from "@/pbjs/external/auth/auth_pb";
import { ExecType } from "@/pbjs/xcommon/enum_pb";
import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";

@Component({
  name: "addnewTalkPoint",
  components: {
    MaskComponent: () => import("./Mask.vue"),
  },
})
export default class addnewTalkPoint extends Vue {
  @Prop() flag: any;
  @Prop() selectText: any;
  @Prop() selectTextId: any;
  @Prop() dataRes: any;
  @Prop() caseresultListDataS: any;
  @Provide() private userForm: any = {
    TalkPointName: null,
    keywordsPhrases: null,
  };
  @Provide() private dynamicTags: any = [];
  @Provide() private checkedRule: any = [];
  @Provide() private checked: any = [];
  @Provide() private checkedRuleid: any = [];
  @Provide() private checkedNodes: any = [];

  @Provide() private dataTree: any = [];
  @Provide() private inputVisible: boolean = false;
  @Provide() private showDialogTypeId: number = 0;
  @Provide() private inputValue: any = "";
  @Provide() private filterText: any = "";
  @Provide() private options: any = [
    { id: "1", val: "dashbordDy.AddPoints" },
    { id: "2", val: "dashbordDy.MinusPoints" },
  ];
  @Provide() private defaultProps: any = {
    children: "children",
    label: "label",
  };
  @Watch("filterText")
  onAmountChanged(val: number | null) {
    (this.$refs.tree as any).filter(val);
  }
  @Watch("caseresultListDataS")
  onChanged(val: any | null) {
    this.dataTree = [];
    let children: any = [];
    val.forEach((item: any, index: any) => {
      item.qualitypointlistList.forEach((it: any, o: any) => {
        //
        if (it.scriptpoint.data.status == 1) {
          children.push({
            id: o,
            label: it.scriptpoint.data.scriptname,
            scriptnameid: it.scriptpoint.data.id,
            scripttextList: it.scriptpoint.data.scripttextList,
          });
        }

      });
      this.dataTree.push({
        id: item.id,
        label: item.rulename,
        scorepolicy: item.scorepolicy,
        scorevalue: item.scorepolicy.toString(), //item.score > 0 ? "1" : "2",
        score: item.score,
        status: item.status,
        username: item.username,
        selectText: this.selectText,
        selectTextId: this.selectTextId,
        children,
      });
      children = [];
    });
    this.checkedNodes = [];
  }
  private created() {
    let children: any = [];
    this.dataTree = [];
    this.caseresultListDataS.forEach((item: any, index: any) => {
      item.hitwordList.forEach((it: any, o: any) => {
        // children=[]
        children.push({
          id: o,
          label: it,
        });
      });
      this.dataTree.push({
        id: index,
        label: item.rulename,
        scorevalue: "1",
        score: item.score,
        status: item.status,
        username: item.username,
        children,
      });
      children = [];
    });
  }
  private mounted() {}
  private hideMaskVue() {
    this.$emit("hideManualUpgradeTicketDialogue", {
      hidden: true,
      val: null,
    });
  }
  private closeDialog() {
    this.$emit("hideManualUpgradeTicketDialogue", {
      hidden: true,
      val: 0,
    });
  }
  private open() {
    this.$confirm(this.$tc("dashbordDy.previouspage"), "提示", {
      confirmButtonText: this.$tc("dashbordDy.confirmreturn"),
      cancelButtonText: this.$tc("dashbordDy.continueediting"),
      type: "warning",
    })
      .then(() => {
        this.closeDialog();
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // });
      })
      .catch(() => {
        // this.$message({
        //   type: "info",
        //   message: "已取消删除",
        // });
      });
  }
  private testRule() {

    if (this.checkedNodes && this.checkedNodes.length > 0) {
      return true;
    } else {
      this.$message({
        type: "error",
        message: "pls check the form value!",
      });
      return false;
    }
  }
  private filterNode(value: any, data: any) {
    if (!value) return true;
    return data.label.indexOf(value) !== -1;
  }

  //新建规则
  private addQCrule() {
    let routeData: any = this.$router.resolve({
      path: "/addNewRules",
      query: { id: "" },
    });
    window.open(routeData.href, "_blank");
  }
  private getCheckedNodes(data: any, checked: any) {
    let arr: any = [];
    this.checkedRule = checked.halfCheckedNodes;
    this.checkedNodes = checked.checkedNodes;
    this.checkedRuleid = checked.halfCheckedKeys;
  }
  //保存人工质检数组
  private savecheckedRule() {
    this.$emit("savecheckedRule", { val: true });
  }
  //baocun
  private submitPoint() {
    if (this.testRule()) {
      if ((this.$refs.tree as any).getNode()) {
        let node = (this.$refs.tree as any).getNode(this.dataTree[0].id).parent;

        node.childNodes.map((val: any) => {
          val.checked = false;
          if (val.childNodes && val.childNodes.length > 0) {
            val.childNodes.map((value: any) => {
              value.checked = false;
            });
          }
        });
      }
      //  else{
      //    let CheckedNodes = (this.$refs.tree as any).getCheckedNodes();
      //     CheckedNodes
      //  }
      // let node = (this.$refs.tree as any).getNode(this.dataTree[0].id).parent;

      this.savecheckedRule();
      this.$message.success("success");
      this.closeDialog();
    }
  }
}
